import React, { useCallback, useEffect, useRef } from 'react';

import { FormattedMessage, formatTranslation } from 'intl';
import { DialogTranslationKeys } from 'intl/keys';
import { useIntl } from 'react-intl';
import { useDialog } from '../Dialog/common/DialogContext';
import useFormEdit from '../../../views/issue/forms/useFormEdit';

interface LeaveDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const LeaveDialog = ({
  open,
  onConfirm,
  onCancel,
}: LeaveDialogProps): JSX.Element => {
  const { clearAllForms } = useFormEdit();
  const createDialog = useDialog();
  const openRef = useRef(open);
  const intl = useIntl();

  const showDiscardDialog = useCallback(
    (onConfirm): Promise<void> => {
      const handleSubmit = (): void => {
        onConfirm();
        clearAllForms();
      };

      return createDialog({
        catchOnCancel: true,
        title: formatTranslation(intl, DialogTranslationKeys.confirmationDiscardChangesTitleWeb,),
        description: (
          <span>
            <FormattedMessage id={DialogTranslationKeys.confirmationDiscardChangesWeb} />
          </span>
        ),
      })
        .then(handleSubmit)
        .catch(onCancel);
    },
    // eslint-disable-next-line
    []
  );

  useEffect(() => {
    openRef.current = open;
  }, [open]);

  useEffect(() => {
    if (openRef.current) {
      showDiscardDialog(onConfirm);
    }
  }, [onConfirm, showDiscardDialog]);

  return <div />;
};

export default LeaveDialog;
